/*
  * Prescription compoenent
*/
if (!customElements.get('my-prescription')) {
  class myPrescription extends HTMLElement {
    constructor() {
      super();
      
      this.submitBtn = this.querySelector('button[type="submit"]');
      this.prescriptiondataWrapper = this.querySelector('[data-prescriptiondata]');
      this.prescriptionLinks = this.querySelector('[data-prescriptionLinks');
      this.prescriptionLinksJson = this.querySelector('[data-prescriptionListJson]') 
      if (this.prescriptionLinksJson) this.prescriptionLinksJson = JSON.parse(this.prescriptionLinksJson.textContent)
      this.revealFormEle = this.querySelector('[data-revealForm]');
      this.formEle = this.querySelector('form');

      this.init();
    }

    /*
      * click to open prescription upload form
    */
    openForm = () => {
      this.revealFormEle?.addEventListener('click', () => {
        this.revealFormEle.style.display = 'none';
        if (this.formEle) this.formEle.style.display = '';
      })
    }

    /*
      * Get Links Data and render on viewport
    */
    renderLinks = (data) => {
      let linksHtml = '';
      data?.forEach(link => {
        let fileTitle = link.split('/').pop();
        linksHtml += `<li>
                        <a href="${link}" target="_blank">${fileTitle}</a>
                      </li>`;
      });
      this.prescriptionLinks.innerHTML = linksHtml;
      if(data) this.prescriptiondataWrapper.style.display = '';
    }

    /*
      * Submit prescription form
    */
    onSubmit = () => {
      let statusCode;
      this.formEle?.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submitBtn.disabled = true;
        this.submitBtn.classList.add('loading');
        let statusCode;
        let url = e.currentTarget.action,
            body = new FormData(e.currentTarget);
        fetch(url, {
          method: 'POST',
          body: body
        })
        .then(res => {
            statusCode = res.status;
            return res.json();
          })
        .then(data => {
          this.submitBtn.disabled = false;
          this.submitBtn.classList.remove('loading');
          if (statusCode == 422) {
            let alertHtml = `<p class="alert alert-danger">${data.message}</p>`;
            this.formEle.insertAdjacentHTML('afterbegin',alertHtml);
            setTimeout(() => {
              this.querySelector('.alert-danger').remove();
            }, 5000);
          } else {
            let alertHtml = `<p class="alert alert-success">${data.message}</p>`;
            this.formEle.insertAdjacentHTML('afterbegin',alertHtml);

            this.renderLinks(data.files);

            this.formEle.reset();
            setTimeout(() => {
              this.querySelector('.alert-success').remove();
            }, 5000);
          }
        })
        .catch(err => {
          let alertHtml = `<p class="alert alert-danger">${err.message}</p>`;
          this.formEle.insertAdjacentHTML('afterbegin',alertHtml);
          setTimeout(() => {
            this.querySelector('.alert-danger').remove();
          }, 5000);
        })
      })
    }

    init() {
      this.renderLinks(this.prescriptionLinksJson);
      this.onSubmit();
      this.openForm();
    }
  }
  customElements.define('my-prescription', myPrescription);
}